"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoFishManagingGamesClient = GoFishManagingGamesClient;
function GoFishManagingGamesClient(apiEndpoint) {
    return {
        async createGame(template) {
            const url = `${apiEndpoint}${apiEndpoint.endsWith("/") ? "" : "/"}api/game`;
            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ template: template }),
            });
            if (!response.ok)
                throw new Error(`Failed to create game: ${response.status}`);
            return await response.text();
        },
    };
}
